import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  SelectProps,
  SxProps,
  Theme,
} from '@mui/material';
import React, { forwardRef, memo } from 'react';

export type Option = {
  label: string;
  value: any;
};

interface BookingFormSelectProps extends SelectProps {
  value?: any;
  options?: Option[];
  label: string | React.ReactNode;
  error?: boolean;
  helperText?: string | null;
  sx?: SxProps<Theme>;
  [key: string]: any;
}

const BookingFormSelect = forwardRef<any, BookingFormSelectProps>((props, ref) => {
  const {
    value,
    onChange,
    onBlur,
    options,
    label,
    error,
    helperText,
    register,
    sx,
    required,
    ...otherProps
  } = props;

  return (
    <FormControl fullWidth variant="filled" error={error} sx={{ minHeight: 48, ...sx }}>
      <InputLabel required={required}>{label}</InputLabel>
      <Select
        ref={ref}
        label={label}
        value={value}
        onChange={(e, child) => {
          onChange?.(e, child);
          register?.onChange(e.target.value);
        }}
        size="small"
        sx={{
          borderRadius: 2,
          backgroundColor: 'transparent',
          fontSize: 15,
          minHeight: 56,
          '&:hover': {
            backgroundColor: 'transparent',
          },
          '&.Mui-focused': {
            backgroundColor: 'transparent',
          },
          '& .MuiSelect-select:focus': {
            backgroundColor: 'transparent',
          },
          '& .MuiFilledInput-root': {
            backgroundColor: 'transparent',
            '&:hover': {
              backgroundColor: 'transparent',
            },
            '&.Mui-focused': {
              backgroundColor: 'transparent',
            },
          },
        }}
        {...otherProps}
      >
        {options &&
          options.map((option, index) => (
            <MenuItem key={index} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
      </Select>
      {helperText && helperText !== null && (
        <FormHelperText>{helperText}</FormHelperText>
      )}
    </FormControl>
  );
});

BookingFormSelect.displayName = 'BookingFormSelect';

export default memo(BookingFormSelect);